// extracted by mini-css-extract-plugin
export default {"recordTags":"RecordTags_recordTags__SDQe3","tag":"RecordTags_tag__aUJ4J"};